module.exports = __webpack_public_path__ + "static/img/9.45acfde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/zh/9.png
// module id = FT43
// module chunks = 0